import { render, staticRenderFns } from "./our-story-section.vue?vue&type=template&id=0ea76bb6&scoped=true&"
import script from "./our-story-section.vue?vue&type=script&lang=ts&"
export * from "./our-story-section.vue?vue&type=script&lang=ts&"
import style0 from "./our-story-section.vue?vue&type=style&index=0&id=0ea76bb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea76bb6",
  null
  
)

export default component.exports